import { useState } from 'react'
import { useNavigation } from '@react-navigation/native'
import Toast from 'react-native-toast-message'
import { useForgotPassword as useForgotPasswordMutation } from '@hooks'
import type { GenericNavigationProp } from '@navigation'
import { useLanguage } from '@context'
import { translateApiError } from '@utils'

interface UseForgotPasswordResult {
  email: string
  setEmail: React.Dispatch<React.SetStateAction<string>>
  handleForgotPassword: () => void
  isPending: boolean
  error: string
}

export const useForgotPassword = (): UseForgotPasswordResult => {
  const { t } = useLanguage()
  const navigation = useNavigation<GenericNavigationProp>()
  const [email, setEmail] = useState('')
  const [error, setError] = useState('')

  const { mutate: forgotPasswordMutation, isPending } = useForgotPasswordMutation()

  const handleForgotPassword = () => {
    setError('')

    if (!email?.trim()) {
      setError(t('forgotPassword.error.noEmail'))
      return
    }

    forgotPasswordMutation(
      { email: email.trim() },
      {
        onSuccess: () => {
          Toast.show({
            type: 'success',
            text2: t('forgotPassword.success'),
          })
          navigation.goBack()
        },
        onError: (err) => {
          const { message } = translateApiError(t, err)
          setError(message)
        },
      },
    )
  }

  return {
    email,
    setEmail,
    handleForgotPassword,
    isPending,
    error,
  }
}
